<template>
  <router-link :to="{ name: 'agent', params: { slug: agent.slug} }">
    <div class="box is-marginless is-radiusless has-text-justified">
      <b-columns is-mobile>
        <b-column class="is-full wrap-text">
          <div class="has-text-weight-semibold">
            {{ agent.trivial_name }}
            <button
              class="button has-text-white type-button is-pulled-right"
              :class="backgroundByAgentCategory(agent.agent_type)"
            >
              {{ agentCategoryLabel(agent.type_field) }}
            </button>
          </div>
          <div>{{ agent.name }} </div>
          <div>Cas: {{ agent.cas_number }}</div>
          <div>UN:
            <span
              v-for="(un,idx) in agent.un_numbers"
              :key="idx"
            >
              {{ un }}
            </span>
          </div>
        </b-column>
      </b-columns>
    </div>
  </router-link>
</template>

<script>
import { colorByAgentCategory } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'agentCategoryLabel'
    ])
  },
  mixins: [colorByAgentCategory]
}
</script>
